// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en.json';
import jaTranslation from './locales/ja.json';
import koTranslation from './locales/ko.json';

i18n
  .use(initReactI18next)  // react-i18next와 연결
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      ja: {
        translation: jaTranslation,
      },
      ko: {
        translation: koTranslation,
      },
    },
    lng: 'en', // 기본 언어 설정
    fallbackLng: 'en', // 번역이 없을 때 기본 언어로 fallback
    interpolation: {
      escapeValue: false, // 리액트에서 안전하게 텍스트 삽입
    },
  });
  
  export default i18n;
